<template>
  <div class="contentPage">
    <main-table-all-back
        v-if="customerInvoicesLimit"
        textCreate="Add invoice"
        :flag="flag"
        page-title="Customer invoices"
        :headers="headers"
        :settings="getSettings"
        :filtersList="customerInvoicesFilters"
        :list="customerInvoicesList"
        :defaultOrder="customerInvoicesOrder"
        :defaultSort="customerInvoicesSort"

        :totals="customerInvoicesTotals"
        :total-pages="customerInvoicesTotal"
        :limit-pages="customerInvoicesLimit"
        :pages="[ 20, 50, 100, 200, 500, 'All' ]"
        :uniqId="uniqId"
        :selected="selected"
        @updateSettings="onSettingsOpen"
        @updateEvent="onEvent"
        @updateClickButton="onClickButton"
        @updateModEvent="onModEvent"
        @updateList="onList"
        @updateEdit="onEdit"
        @updateRefreshFilters="onRefreshFilters"
        @updatePaid="onPaid"
        @updateCheckOrder="onCheckOrder($event,'customerInvoicesList', 'invoice_id')"
        @updateCheckOrders="onCheckOrders($event,'customerInvoicesList')"
        @updateExport="onExport"
        @updateCheckAll="onCheckAll"
        :checkAll="checkAll"
        :indeterminate="indeterminate"
        isExport
        is-create
        is-settings
        text-reports="GENERATE INVOICE"
        :permissionsReports="permissionsReports()"
        :permissionsCreate="permissionsCreate()"
        
        :externalRefreshKey="externalRefreshKey"
        :externalResetKey="externalResetKey"
        :externalResetMode="externalResetMode"
    >
	    <template slot="customSubButtons">

		    <button
				    :disabled="permissionsBulkChange"
            @click="openDialogCustomersBulkChange()"
            class="mainBtn mainBtn-text iconScale"
		    >
			    <span class="btnIco"><svg-sprite width="20" height="20" icon-id="users0"></svg-sprite></span>
			    <span class="btnText">Customers bulk change</span>
		    </button>
		    <button
				    :disabled="permissionsSendInvoices"
            @click="sendInvoices()"
            class="mainBtn mainBtn-text iconScale"
		    >
			    <span class="btnIco"><svg-sprite width="20" height="20" icon-id="icon_send"></svg-sprite></span>
			    <span class="btnText">Send selected invoices</span>
		    </button>

	    </template>
    </main-table-all-back>

	  <dialog-info
			  v-if="isDialogInfo"
			  :title="titleDialogInfo"
			  :text="textDialogInfo"
			  @updateApply="onDialogInfoApply"
			  @updateClose="onDialogInfoApply"
	  />
	  <customer-form
			  v-if="isCustomerForm"
			  :id="idCustomer"
			  @updateClose="onCloseCustomerForm"
			  @updateSave="onSaveCustomerForm"
	  ></customer-form>

	  <generate-invoice
			  v-if="isGenerateInvoice"
			  @updateClosePopup="onCloseGenerateInvoice"
			  @updateGenerate="onGenerate"
			  :customers-list="customers"
			  :service-list="service"
	  ></generate-invoice>

	  <preload v-if="isPreloader"></preload>

	  <table-settings
        v-if="isTableSettingsDrawer"
        @updateSettingsSave="onSettingsSave('invoice')"
        @updateSettingsCancel="onSettingsCancel"
        @updateSettingsClose="onSettingsClose"
        @updateSettingsAll="onSettingsAll"
        :settings="getSettings"
    ></table-settings>
    <remove-block
        v-if="isRemove"
        z-index="100"
        @updateRemoveItem="onRemoveItem"
        @updateRemoveClose="onRemoveClose"
    ></remove-block>
    <send-invoices
        v-if="selectedInvoices"
        :selectedInvoices="selectedInvoices"
        @updateSendInvoicesClose="onClosePopup"
        @updateLink="onPreview"
    ></send-invoices>
    <send-reports
        v-if="isSendReports"
        :sendReportsData="sendReportsData"
        @updateSendReportsClose="onCloseDialog"
    ></send-reports>
    <customer-invoices-payments
        v-if="customerInvoicesPayment"
        :customerInvoicesPayment="customerInvoicesPayment"
        @updateClose="onClosePopup"
    ></customer-invoices-payments>

	  <dialog-table
			  v-if="isFileReportMod"
			  :list="invoiceFiles"
			  :title="viewReportTitle"
			  :headers="getInvoiceFilesHeaders"
			  flag="invoiceFilesHeaders"
			  @updateClose="onCloseDialogTable"
			  @updateClickButton="onClickButtonDialogTable"
			  :no-info="noInfoText"
	  />

	  <preview-doc v-if="linkPreviewDoc" @clear-link="clearLinkPreviewDoc" :link-doc="linkPreviewDoc"></preview-doc>

    <preview-document v-if="previewLink"></preview-document>

    <customer-invoices-create
        v-if="isCustomerInvoicesCreate"
        :title="`${invoiceId ? 'Edit': 'Add'} invoice`"
        :invoiceId="invoiceId"
        @updateCloseDialog="onCloseDialog"
        @updateView="onPreview"
    ></customer-invoices-create>

	  <dialog-remove
			  v-if="isDialogRemove"
			  :titleRemove="titleRemove"
			  :textRemove="textRemove"
			  @updateRemove="onRemove"
			  @updateCloseRemove="onCloseRemove">
	  </dialog-remove>
	  <customers-bulk-change
			  v-if="isCustomersBulkChange"
			  :list="customersFromFilteredResultFull"
			  @updateCloseDialog="onCloseDialogCustomersBulkChange"
			  @updateApply="onCustomersBulkApply"
	  >
	  </customers-bulk-change>
  </div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import SendInvoices from "@/components/Accounting/CustomerInvoices/SendInvoices/SendInvoices.vue";
import SendReports from "@/components/Accounting/CustomerInvoices/SendReports/SendReports.vue";
import CustomerInvoicesPayments
from "@/components/Accounting/CustomerInvoices/CustomerInvoicesPayments/CustomerInvoicesPayments.vue";
import CustomerInvoicesCreate
from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/CustomerInvoicesCreate.vue";
const CustomerForm = () => import("@/components/Maintenance/Customer/CustomerForm/CustomerForm");

// shared
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument.vue";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
import previewMixins from "@/mixins/previewMixins";
// constants
import { PAGE, PERMISSIONS, TEXT, TITLE } from "@/constants/constants";
import checkBoxOrders from "@/mixins/checkBoxOrders";
import { viewReportHeader, viewReportTitles } from "@/components/Accounting/CustomerInvoices/constants";
// import getUniqId from "@/helper/getUniqId";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import GenerateInvoice from "@/pages/Accounting/CustomerInvoices/GenerateInvoice/GenerateInvoice.vue";
import Preload from "@/shared/Preload/Preload.vue";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import DialogTable from "@/shared/DialogTable/DialogTable.vue";
// import { getAppUrl } from "@/services";
import PreviewDoc from "@/modules/invoices/preview.vue";
import DialogInfo from "@/shared/DialogInfo/DialogInfo.vue";
import getUniqId from "@/helper/getUniqId";
import CustomersBulkChange from "@/shared/CustomersBulkChange/CustomersBulkChange.vue";

export default {
	name: "CustomerInvoices",
	mixins: [ settingsMixins, removeMixins, previewMixins, checkBoxOrders ],
	components: {
		CustomersBulkChange,
		DialogInfo,
		PreviewDoc,
		DialogTable,
		Preload,
		GenerateInvoice,
		DialogRemove,
		PreviewDocument,
		MainTableAllBack,
		SendInvoices,
		SendReports,
		CustomerInvoicesPayments,
		CustomerInvoicesCreate,
		CustomerForm,
	},
	computed: {
		...mapGetters([
			"customerInvoicesList",
			"customerInvoicesFilters",
			"customerInvoicesTotals",
			"permissions",
			"selectedInvoices",
			"customerInvoicesPayment",
			"customerInvoicesOrder",
			"customerInvoicesLimit",
			"customerInvoicesSort",
			"customerInvoicesTotal",
			"invoiceFiles",
			"activeFilters", // Получаем фильтры из Vuex
			'permissionsDefault',
			'isLogin',
		]),
		permissionsBulkChange() {
			const { role } = this.isLogin;

			return ![ 3, 38 ].includes(Number(role));
		},
		permissionsSendInvoices() {
			// 1. Отримуємо список прав
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.SEND ];

			// 2. Перевіряємо — чи є дозвіл
			const hasPermission = getPermissionsMod({ list, path });

			// 3. Якщо прав немає — дизейбл
			if (!hasPermission) return true;

			// 4. Якщо прав є, але немає вибраних елементів — дизейбл
			if (!this.selected || !this.selected.length) return true;

			// 5. Якщо все добре — активна кнопка
			return false;
		},
		getInvoiceFilesHeaders() {
			return viewReportHeader;
		},

		customersFromFilteredResultFull() {
			const list = Array.isArray(this.customerInvoicesList) ? this.customerInvoicesList : [];
			const map = new Map();

			list.forEach(function(row) {
				if (!row || row.customer_id == null) return;

				// ✅ кладём всю строку (полный row)
				if (!map.has(row.customer_id)) {
					map.set(row.customer_id, row);
				}
			});

			return Array.from(map.values()).sort(function(a, b) {
				return String(a.customer || '').localeCompare(String(b.customer || ''));
			});
		}
	},
	data: () => ({
		flag: PAGE.INVOICE,
		viewReportTitle: '',
		isSendReports: false,
		sendReportsData: false,
		isView: false,
		isCustomerInvoicesCreate: false,
		invoiceId: false,
		defaultFilter: null,
		activeTableFilters: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		activeKey: null,
		customers: null,
		service: null,
		isGenerateInvoice: false,
		isPreloader: false,
		isFileReportMod: false,
		linkPreviewDoc: null,
		noInfoText: null,

		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)
		
		isDialogInfo: false,
		titleDialogInfo: null,
		textDialogInfo: null,

		isCustomerForm: false,
		idCustomer: null,

		isCustomersBulkChange: false,
	}),
	methods: {
		...mapActions([
			"getCustomerInvoices",
			"getSelectedInvoices",
			"getCustomerInvoicesTotal",
			"getCustomerInvoicesPayment",
			"onCustomerInvoicesClear",
			"getCustomerInvoicesFilters",
			"onExportLink",
			"onDeleteInvoice",
			"setAlert",
			"actionPreloader",
			"getInvoiceFiles",
			"getInvoiceOpen",
			"onSelectedInvoicesClear",
			"updateActiveFilters", // Экшен для обновления фильтров
			"resetActiveFilters", // Экшен для сброса фильтров
			"getGenerateInvoice",
			"onGenerateInvoice",
		]),

		async sendInvoices() {
			const invoice = this.selected
				.filter(item => item.status === 'Closed')
				.map(item => ({ id: item.invoice_id }));
			await this.getSelectedInvoices({ invoice });
		},
		onCloseDialogCustomersBulkChange() {
			this.externalRefresh();
			this.isCustomersBulkChange = false;

		},
		onCustomersBulkApply(payload) {
			// payload = { customers: [984, 123, ...] }
			// ✅ тут ты решаешь что с этим делать: отправить запрос, сохранить в store, и т.д.

			console.log('%c [  payload  ] ', 'color:#bada55', typeof payload, payload );
			this.isCustomersBulkChange = false;
		},

		openDialogCustomersBulkChange() {
			this.isCustomersBulkChange = true;
		},

		permissionsCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.CREATE ];
			return !getPermissionsMod({ list, path });
		},
		permissionsReports() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.INVOICE_GENERATOR ];
			return !getPermissionsMod({ list, path });
		},
		async onGenerate(value) {
			await this.onGenerateInvoice(value);
			this.isGenerateInvoice = false;
		},
		onCloseGenerateInvoice() {
			this.isGenerateInvoice = false;
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onRemove() {

			if (this.activeKey === 'open' ) {
				await this.getInvoiceOpen(this.activeItem.invoice_id);

				// if (isSuccess) {
				// 	await this.onUpdateFiltersMod();
				// } else {
				// 	console.error("❌ Ошибка при отправке");
				// }
			}

			if (this.activeKey === 'delete' ) {
				await this.onDeleteInvoice(this.activeItem.invoice_id);
				// await this.onUpdateFilters(this.defaultFilter);
			}
			this.onCloseRemove();
			this.externalRefresh();
		},

		async onUpdateFilters(filters, isWithoutFilters) {

			// Сохраняем фильтры в Vuex
			await this.updateActiveFilters(filters);

			// Загружаем данные с учетом фильтров
			await this.getCustomerInvoices(filters);
			if (!isWithoutFilters) await this.getCustomerInvoicesFilters(filters);
			await this.getCustomerInvoicesTotal(filters);

		},
		onClosePopup(isUseDefaultFilters) {
			this.onSelectedInvoicesClear();
			this.isSendReports = false;
			if (isUseDefaultFilters) {
				// this.onUpdateFilters(this.defaultFilter);
				this.externalRefresh();
			}
			// Сброс вібранніх єлементов
			this.onCheckOrders(false, 'customerInvoicesList');
		},
		onCheckAll() {
			this.checkAll = false;
			this.indeterminate = false;
			this.selected = [];
		},
		onCloseDialog(isUseDefaultFilters) {
			this.getInvoiceFiles(null);
			this.isSendReports = false;
			this.isCustomerInvoicesCreate = false;
			if (isUseDefaultFilters) {
				this.externalRefresh();
				// this.onUpdateFilters(this.defaultFilter);
			}
		},
		onCloseDialogTable() {
			this.isFileReportMod = false;
			this.noInfoText = null;
		},
		async onClickButtonDialogTable({ key, item }) {
			if (key === "view") {
				// this.linkPreviewDoc = getAppUrl + item.file;
				this.linkPreviewDoc = item.url;
			}
		},
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},

		onModEvent(args) {
			const { line, flag } = args;

			if (flag === 'link') {
				this.isCustomerForm = true;
				this.idCustomer = line.customer_id;
			}
			if (flag === 'info') {
				const title = `Safety Service Info — <b>${ line.customer_name }</b>`;
				const text = line.information;
				this.initDialogInfo({ title, text });
			}
		},

		initDialogInfo(args) {
			const { title, text } = args;
			this.titleDialogInfo = title;
			this.textDialogInfo = text;
			this.isDialogInfo = true;
		},
		onDialogInfoApply() {
			this.isDialogInfo = false;
		},

		onSaveCustomerForm() {
			this.onCloseCustomerForm();
			this.externalRefresh();
		},
		onCloseCustomerForm() {
			this.isCustomerForm = false;
			this.idCustomer = null;
		},

		async onClickButton({ key, item }) {

			this.activeItem = item;
			this.activeKey = key;
			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					// this.getRemoveItem(item.invoice_id);
					const title = TITLE.DELETE_INVOICE;
					const text = TEXT.DELETE_INVOICE;
					this.onRemoveDialog({ title, text });
				}
			}

			if (key === "send") {
				this.sendReportsData = item;
				this.isSendReports = true;
			}

			// if (key === "file_report") {
			// 	this.viewReportTitle = viewReportTitles.VIEW_FILES;
			// 	await this.getInvoiceFiles(item.invoice_id);
			// 	this.isView = true;
			// }

			if (key === "file_report_mod") {
				this.viewReportTitle = viewReportTitles.VIEW_FILES;
				await this.getInvoiceFiles(item.invoice_id);
				this.isFileReportMod = true;
				this.noInfoText = `📂 No files have been uploaded for customer ${ item.customer } yet.`;
			}

			// if (key === "download") {
			// 	this.viewReportTitle = viewReportTitles.DOWNLOAD_FILES;
			// 	await this.getInvoiceFiles(item.invoice_id);
			// 	this.isView = false;
			// }

			if (key === "open") {
				if (this.permissions[PERMISSIONS.OPEN_INVOICE]) {
					const title = TITLE.OPEN_INVOICE;
					const text = TEXT.OPEN_INVOICE;
					this.onRemoveDialog({ title, text });
				}
			}

		},
		updateClose() {
			this.isFileReportMod = false;
			this.noInfoText = null;
		},
		async onEvent(flag) {
			if (flag === "create") {
				this.isCustomerInvoicesCreate = true;
				this.invoiceId = null;
			}

			if (flag === "reports") {
				this.isPreloader = true;
				const { customers, service } = await this.getGenerateInvoice();
				this.customers = customers;
				this.service = service;

				if (customers && service) this.isGenerateInvoice = true;

				this.isPreloader = false;
			}
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getCustomerInvoices(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},

		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

		onEdit({ line }) {
			if (line.status === 'Open') {
				this.isCustomerInvoicesCreate = true;
				this.invoiceId = line['invoice_id'];
			}
		},
		onRefreshFilters() {
			this.resetActiveFilters(); // Очищаем фильтры в Vuex
			this.onCheckAll();
			this.onUpdateFilters(this.defaultFilter);
		},
		async onPaid({ line }) {
			await this.getCustomerInvoicesPayment(line.invoice_id);
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'invoice' });
		},
		// async onRemoveItem() {
		// 	this.actionPreloader(true);
		// 	const resp = await this.onDeleteInvoice(this.removeId);
		// 	if (resp) {
		// 		this.isRemove = false;
		// 		await this.onUpdateFilters(this.defaultFilter);
		// 		this.actionPreloader(false);
		// 		this.setAlert({ type: "success", message: "The removal was successful" });
		// 	} else {
		// 		this.setAlert({ type: "error", message: "Deletion error" });
		// 	}
		// },

		async onUpdateFiltersMod() {
			if (this.activeFilters && Object.keys(this.activeFilters).length) {
				await this.onUpdateFilters(this.activeFilters);
			} else {
				await this.onUpdateFilters();
			}
		}
	},
	async mounted() {
		await this.onUpdateFiltersMod();
	},
	destroyed() {
		this.onCustomerInvoicesClear();
	}
};
</script>
<style lang="scss" scoped>
@import "customerInvoices";
</style>
<style lang="scss">

.pageList--table {

}

.v-application--is-ltr .pageList--table .v-input--selection-controls__input {
	margin-right: 0;
}

</style>
